import { useFormContext } from "react-hook-form";
import { FileList, FileListProps } from "./FileList";
import { InputLabel } from "../InputLabel/InputLabel";
import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";

interface PaziaFileListProps extends Omit<FileListProps, "onDrop"> {
  name: string;
  required?: boolean;
  label?: string;
  className?: string;
}
export const PaziaFileList = ({
  name,
  required,
  label,
  multiple,
  className = "",
}: PaziaFileListProps) => {
  const { setValue, getValues } = useFormContext();
  const values = getValues()[name];

  return (
    <div className={className}>
      <InputLabel name={name} label={label} required={required} />
      <FileList
        onDrop={(x) => {
          const value = !multiple ? x[0] : x;
          setValue(name, value, { shouldDirty: true });
        }}
        defaultValues={values}
        multiple={multiple}
      />
      <InputErrorMessage name={name} />
    </div>
  );
};
